<nav class="bg-light border-right vh-100 overflow-auto pt-2">
  <ul class="nav flex-column">
    @if (isNavBarSettingsActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="start" routerLinkActive="nav-link-active">Ersteinrichtung</a>
      </li>
    }
    @if (isNavBarSettingsActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="domains" routerLinkActive="nav-link-active">Domains</a>
      </li>
    }
    @if (isNavBarSettingsActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="whitelisting" routerLinkActive="nav-link-active">Whitelisting</a>
      </li>
    }
    @if (isNavBarSettingsActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="reporting-settings" routerLinkActive="nav-link-active">Reporting</a>
      </li>
    }
    <!-- payment ausblenden. -->
    <!-- @if (isNavBarSettingsActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="payment" routerLinkActive="nav-link-active">Zahlung</a>
      </li>
    } -->
    @if (isNavBarSettingsActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="profile" routerLinkActive="nav-link-active">Profil</a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="phishing-dashboard" routerLinkActive="nav-link-active">Dashboard</a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="phishing-campaigns" routerLinkActive="nav-link-active">Kampagnen</a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="phishing-users-and-groups" routerLinkActive="nav-link-active">
          Empfängergruppen
        </a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="phishing-email-templates-dashboard" routerLinkActive="nav-link-active">
          E-Mail Vorlagen
        </a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="phishing-landing-pages-dashboard" routerLinkActive="nav-link-active">
          Landing Pages
        </a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="phishing-learning-pages-dashboard" routerLinkActive="nav-link-active">
          Learning Pages
        </a>
      </li>
    }
    @if (isNavBarPhishingActive()) {
      <li class="nav-item">
        <a class="nav-link" routerLink="certification" routerLinkActive="nav-link-active">Teilnahmezertifikat</a>
      </li>
    }
  </ul>
</nav>
